import { Component, Input } from '@angular/core';

@Component({
  selector: 'love-full-icon',
  templateUrl: 'love-full-icon.html'
})
export class LoveFullIconComponent {
  @Input() width: string;
  @Input() height: string;
  constructor() {
    if (!this.width) {
      this.width = '16';
    }
    if (!this.height) {
      this.height = '16';
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/love-full-icon/love-full-icon.ts